import React from 'react'
import { Dropdown } from 'react-bootstrap'

const AnalyticsPdfSourceDropdown = ({ selectedSource, sources, onSelect }) => (
  <Dropdown>
    <Dropdown.Toggle variant="outline-secondary" size="sm">
      {selectedSource === 'all'
        ? 'All Sources'
        : sources.find((s) => s.value === selectedSource)?.label || 'All Sources'}
    </Dropdown.Toggle>
    <Dropdown.Menu>
      <Dropdown.Item active={selectedSource === 'all'} onClick={() => onSelect('all')}>
        All Sources
      </Dropdown.Item>
      <Dropdown.Divider />
      {sources.map((source) => (
        <Dropdown.Item
          key={source.value}
          active={selectedSource === source.value}
          onClick={() => onSelect(source.value)}
        >
          {source.label}
        </Dropdown.Item>
      ))}
    </Dropdown.Menu>
  </Dropdown>
)

export default AnalyticsPdfSourceDropdown
